import { IRestfulConfigMap } from "@core/data-access/restful";
import { appConfig } from "@env/app-config";
import { envConfig } from "@env/env-config";

let UserDataProxyConfig: IRestfulConfigMap = {
    userDataProxy: {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取用户偏好设置
            get: {
                method: "get",
                path: "/api/userPreferences",
                testPath: "/api/userPreferences",
                isAuth: true,
                requestConfig: {
                    headers: {
                        platform: appConfig.websiteCode
                    }
                }
            },
            // 设置用户偏好设置
            updateUserPreferences: {
                method: "put",
                path: "/api/userPreferences",
                testPath: "/api/userPreferences",
                isAuth: true,
                requestConfig: {
                    headers: {
                        platform: appConfig.websiteCode
                    }
                },
            },
        }
    },
};

export { UserDataProxyConfig };
